module.exports = __webpack_public_path__ + "img/Amazon_Web_Services-Logo.wine.59a82d54.svg";